<template>
  <div
    class="mp-chat-item"
    :class="{ 'mp-chat-item--active': active }"
    @click="$emit('select')"
  >
    <div v-if="!editing" class="mp-chat-item__body">
      <svg v-if="chat.is_pinned" class="mp-chat-item__pin" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"/>
      </svg>
      <span class="mp-chat-item__name">{{ chat.name }}</span>
      <div class="mp-chat-item__actions">
        <button class="mp-item-btn" title="Épingler" @click.stop="$emit('pin')">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"/>
          </svg>
        </button>
        <button class="mp-item-btn" title="Renommer" @click.stop="startEdit">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
        </button>
        <button class="mp-item-btn mp-item-btn--danger" title="Supprimer" @click.stop="$emit('delete')">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6M14 11v6"/>
            <path d="M9 6V4h6v2"/>
          </svg>
        </button>
      </div>
    </div>
    <div v-else class="mp-chat-item__edit" @click.stop>
      <input
        ref="nameInput"
        v-model="editName"
        class="mp-item-input"
        @keydown.enter="confirmEdit"
        @keydown.esc="cancelEdit"
        @blur="confirmEdit"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MpChatItem',
  props: {
    chat: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      editing: false,
      editName: '',
    };
  },
  methods: {
    startEdit() {
      this.editName = this.chat.name;
      this.editing = true;
      this.$nextTick(() => this.$refs.nameInput && this.$refs.nameInput.focus());
    },
    confirmEdit() {
      if (this.editName.trim() && this.editName !== this.chat.name) {
        this.$emit('rename', { id: this.chat.id, name: this.editName.trim() });
      }
      this.editing = false;
    },
    cancelEdit() {
      this.editing = false;
    },
  },
};
</script>

<style scoped>
.mp-chat-item {
  position: relative;
  padding: 8px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.1s;
  margin-bottom: 1px;
}
.mp-chat-item:hover {
  background: #f5f5f3;
}
.mp-chat-item--active {
  background: #efefed;
}

.mp-chat-item__body {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.mp-chat-item__pin {
  color: #aeaeb2;
  flex-shrink: 0;
}

.mp-chat-item__name {
  flex: 1;
  font-size: 13px;
  color: #3a3a3c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}
.mp-chat-item--active .mp-chat-item__name {
  color: #1c1c1e;
  font-weight: 500;
}

.mp-chat-item__actions {
  display: none;
  gap: 2px;
  flex-shrink: 0;
}
.mp-chat-item:hover .mp-chat-item__actions,
.mp-chat-item--active .mp-chat-item__actions {
  display: flex;
}

.mp-item-btn {
  background: none;
  border: none;
  color: #aeaeb2;
  cursor: pointer;
  padding: 3px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: color 0.1s, background 0.1s;
}
.mp-item-btn:hover {
  color: #3a3a3c;
  background: #e8e8e6;
}
.mp-item-btn--danger:hover {
  color: #ff3b30;
}

.mp-chat-item__edit {
  padding: 1px 0;
}
.mp-item-input {
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d1d6;
  color: #1c1c1e;
  padding: 4px 7px;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
}
.mp-item-input:focus {
  border-color: #636366;
}
</style>
